<template>
  <div>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="'Danh sách phiếu chuyển cửa hàng'">
      <template v-slot:toolbar>
        <b-button
          v-if="checkPermission('TRANSFER_STORE_FORM_INSERT')"
          @click="showAddTransferStoreFormModal"
          variant="primary"
          size="sm"
        >
          <i style="font-size: 0.7rem" class="flaticon2-add-1" />
          <span class="font-weight-bolder">Thêm mới</span>
        </b-button>
      </template>
      <template v-slot:preview>
        <div class="col-md-12 mb-10">
          <b-row class="mt-3">
            <b-col md="2">
              <b-form-group>
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control form-control-sm date-picker"
                  :config="dpConfigs.date"
                  v-model="params.fromDate"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control form-control-sm date-picker"
                  :config="dpConfigs.date"
                  v-model="params.toDate"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="!isMyForms">
              <EmployeeSearch
                v-model="searchEmployee"
                :employee-id="params.employeeId"
                placeholder="tên nhân viên"
                :limit="params.pageSize"
                @employee-selected="onEmployeeSelected"
              />
            </b-col>
            <b-col md="4" v-else>
              <b-input
                :value="userInfo?.fullName || ''"
                type="text"
                size="sm"
                disabled
                placeholder="Nhân viên"
              />
            </b-col>
            <b-col md="4">
              <EmployeeSearch
                v-model="searchApprovedBy"
                :employee-id="params.approvedById"
                placeholder="tên người duyệt"
                :limit="params.pageSize"
                @employee-selected="onApprovedBySelected"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Autosuggest
                :model="searchCurrentStore"
                :suggestions="filteredOptions"
                placeholder="cửa hàng hiện tại"
                @select="onSelectedCurrentStore"
                :limit="params.pageSize"
                @change="onInputChangeCurrentStore"
                suggestionName="suggestionName"
              >
              </Autosuggest>
            </b-col>
            <b-col md="4">
              <Autosuggest
                :model="searchTargetStore"
                :suggestions="filteredOptions"
                @select="onSelectedTargetStore"
                :limit="params.pageSize"
                placeholder="cửa hàng muốn chuyển đến"
                @change="onInputChangeTargetStore"
                suggestionName="suggestionName"
              ></Autosuggest>
            </b-col>
            <div
              class="d-flex ml-4"
              style="max-height: 32px; align-items: flex-end"
            >
              <b-button-group size="sm">
                <b-button
                  style="width: 70px"
                  class="font-weight-bolder"
                  variant="primary"
                  @click="onFilter"
                  :disabled="isLoading"
                  ><i class="fas fa-search text-white fa-lg"></i>Lọc</b-button
                >
              </b-button-group>
              <b-button
                variant="success"
                size="sm"
                class="mt-3 ml-3"
                style="min-width: 2rem; height: 100%; margin-top: 0"
                @click="reset"
                ><i class="fas fa-sync text-white fa-lg"></i>Làm mới</b-button
              >
            </div>
          </b-row>
          <div v-show="allowUpdateManyItems" v-if="checkAllowUpdateManyItems">
            <b-button
              variant="primary"
              size="sm"
              class="mt-3"
              style="min-width: 5rem"
              v-b-modal.md-change-store
            >
              Duyệt và chuyển</b-button
            >
            <b-button
              variant="success"
              size="sm"
              class="mt-3 ml-3"
              style="min-width: 5rem"
              v-b-modal.modal-approve-many-items
            >
              Duyệt</b-button
            >
            <b-button
              variant="warning"
              size="sm"
              class="mt-3 ml-3"
              style="min-width: 2rem"
              v-b-modal.modal-reject-many-items
              >Từ chối</b-button
            >
            <b-button
              variant="danger"
              size="sm"
              class="mt-3 ml-3"
              style="min-width: 2rem"
              v-b-modal.modal-delete-many-items
              >Xoá đơn</b-button
            >
          </div>
        </div>
        <div class="mb-4 tab-status">
          <b-nav tabs Justified>
            <b-nav-item
              v-for="(status, index) in statusOptions"
              :key="index"
              @click="handleTabsStatus(status.value, index)"
              :active="index == tabIndex ? true : false"
              >{{ status.text }}</b-nav-item
            >
          </b-nav>
        </div>

        <b-table
          :items="listForms"
          :fields="computedFields"
          sort-by="count"
          bordered
          hover
          :busy="isLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:head(selections)>
            <span class="d-flex justify-content-center">
              <b-form-checkbox
                v-model="checkAllItems"
                size="lg"
                @change="onCheckAllItems"
              ></b-form-checkbox>
            </span>
          </template>
          <template v-slot:cell(selections)="row">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                :disabled="checkPermissionByEmployId(row.item) ? false : true"
                :checked="selections.some((id) => id === row.item.id)"
                @change="onSelectFormItem(row.item.id)"
              ></b-form-checkbox>
            </div>
          </template>
          <template v-slot:cell(count)="row">
            <div style="text-align: center">
              <span v-text="row.item.count" class="text-right"></span>
            </div>
          </template>

          <template v-slot:cell(code)="row">
            <a v-bind:href="getLinkDoc(row.item)">
              <span>
                {{ row.item.code }}
              </span>
            </a>
          </template>
          <template v-slot:cell(status)="row">
            <StatusForm
              :status="row.item?.status"
              :timestamp="row.item?.approvedAt"
              :performer="row.item?.approvedByName"
            />
          </template>

          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <b-dropdown-item @click="editItem(row.item)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 10px" class="flaticon2-box-1"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="action in getAvailableActions(row.item)"
                  :key="action.key"
                  @click="action.handler"
                >
                  <span :class="action.class" style="font-size: 12px">
                    <i style="font-size: 10px" :class="action.icon"></i>
                    &nbsp; {{ action.label }}
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ formatMoney(totalItems) }}
            </p></b-col
          >
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="numberOfPages || 1"
              :current-page="params.page"
              :total-page="numberOfPages"
              :linkParams="{}"
              @page-change="fetchTransferStoreForms"
            />
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
    <TransferStoreInformation
      ref="transferStoreInformation"
      :listForm="currentManyFormsOpenModal"
      @fetchTransferStoreForms="fetchTransferStoreForms"
    />

    <AddTransferStoreFormModal
      ref="add-transfer-form-modal"
      @fetchTransferStoreForms="fetchTransferStoreForms"
      :userInfo="userInfo"
      :listStores="options"
      :isMyForms="isMyForms"
    />

    <TransferStoreFormActionModal
      ref="modalApprove"
      modal-id="modal-approve"
      title="Bạn có đồng ý duyệt đơn không?"
      :form-data="currentFormOpenModal"
      confirm-button-text="Tiến hành duyệt"
      confirm-button-variant="success"
      @cancel="hideModalApprove"
      @confirm="onHandleApprove"
    />
    <TransferStoreFormActionModal
      ref="modalApproveTransfer"
      modal-id="modal-approve-transfer"
      title="Bạn có đồng ý duyệt đơn không?"
      :form-data="currentFormOpenModal"
      confirm-button-text="Tiến hành duyệt và chuyển"
      confirm-button-variant="success"
      @cancel="hideModalApproveTransfer"
      @confirm="onHandleApproveTransfer"
    />
    <TransferStoreFormActionModal
      ref="modalReject"
      modal-id="modal-reject"
      title="Bạn có đồng ý từ chối yêu cầu không?"
      :form-data="currentFormOpenModal"
      confirm-button-text="Tiến hành từ chối"
      confirm-button-variant="warning"
      @cancel="hideModalReject"
      @confirm="onHandleReject"
    />
    <TransferStoreFormActionModal
      ref="modalDelete"
      modal-id="modal-delete"
      title="Bạn có đồng ý xoá yêu cầu này không?"
      :form-data="currentFormOpenModal"
      confirm-button-text="Tiến hành xoá đơn"
      confirm-button-variant="danger"
      @cancel="hideModalDelete"
      @confirm="onHandleDelete"
    />
    <TransferStoreFormActionModal
      ref="modalRejectTransfer"
      modal-id="modal-reject-transfer"
      title="Bạn có muốn từ chối đơn này không?"
      :form-data="currentFormOpenModal"
      confirm-button-text="Tiến hành từ chối"
      confirm-button-variant="danger"
      @cancel="hideModalRejectTransfer"
      @confirm="onHandleRejectTransfer"
    />
    <TransferStoreFormManyItemsModal
      ref="modalApproveManyItems"
      modal-id="modal-approve-many-items"
      title="Bạn có đồng ý duyệt đơn không?"
      :forms-data="currentManyFormsOpenModal"
      confirm-button-text="Đồng ý"
      confirm-button-variant="success"
      @cancel="hideModalApproveManyItems"
      @confirm="onHandleApproveManyItems"
    />
    <TransferStoreFormManyItemsModal
      ref="modalRejectManyItems"
      modal-id="modal-reject-many-items"
      title="Bạn có đồng ý từ chối yêu cầu không?"
      :forms-data="currentManyFormsOpenModal"
      confirm-button-text="Tiến hành từ chối"
      confirm-button-variant="warning"
      @cancel="hideModalRejectManyItems"
      @confirm="onHandleRejectManyItems"
    />
    <TransferStoreFormManyItemsModal
      ref="modalDeleteManyItems"
      modal-id="modal-delete-many-items"
      title="Bạn có đồng ý xoá yêu cầu không?"
      :forms-data="currentManyFormsOpenModal"
      confirm-button-text="Tiến hành Xoá đơn"
      confirm-button-variant="danger"
      @cancel="hideModalDeleteManyItems"
      @confirm="onHandleDeleteManyItems"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import {
  convertPrice,
  getEmployeeFromLocal,
  makeToastFaile,
  makeToastSuccess,
} from '@/utils/common';
import { TRANSFER_STORE_STATUS } from '@/utils/constants';
import {
  JOB_TITLE,
  JOB_TITLE_APPROVE,
  TRANSFER_STORE_FORM_STATUS,
} from '@/utils/enum';
import AddTransferStoreFormModal from '@/view/components/transfer-store-form/AddTransferStoreFormModal.vue';
import TransferStoreFormActionModal from '@/view/components/transfer-store-form/TransferStoreFormActionModal.vue';
import TransferStoreFormManyItemsModal from '@/view/components/transfer-store-form/TransferStoreFormManyItemsModal.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue';
import StatusForm from '@/view/components/transfer-store-form/StatusForm.vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Loader from '@/view/content/Loader.vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import { mapGetters } from 'vuex';
import TransferStoreInformation from '../../pages/transfer-store-forms/TransferStoreInformation.vue';
import { handleError } from '../../../utils/common';
import { formatDBDate, convertToDateSlash } from '@/utils/date';
import { VclTable } from 'vue-content-loading';
import permissionMixin from '@/view/mixins/permission.mixin';
import { DP_CONFIG } from '@/utils/date';

export default {
  mixins: [permissionMixin],
  data() {
    return {
      tabIndex: 0,
      search: '',
      searchEmployee: '',
      searchApprovedBy: '',
      searchCurrentStore: '',
      searchTargetStore: '',
      filteredOptions: [],
      params: {
        employeeId: null,
        page: 1,
        status: null,
        pageSize: 10,
        fromDate: null,
        toDate: null,
        currentStoreId: null,
        targetStoreId: null,
      },
      numberOfPages: 1,
      currentPage: 1,
      totalItems: 0,
      count: 1,
      currentApprovedFormId: null,
      currentRejectedFormId: null,
      currentDeletedFormId: null,
      selections: [],
      allowUpdateManyItems: false,
      checkAllItems: false,
      currentFormOpenModal: null,
      currentManyFormsOpenModal: [],
      employeeId: null,
      jobTitleId: null,
      statusEnum: TRANSFER_STORE_FORM_STATUS,
      options: [],
      fields: [
        {
          key: 'selections',
          label: '',
          thStyle: {
            width: '5%',
          },
          requiresPermission: true,
        },
        {
          key: 'employeeCode',
          label: 'Mã NV',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '7%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'employeeName',
          label: 'Tên NV',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '12%',
          },
        },
        {
          key: 'jobTitleName',
          label: 'Chức vụ',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '12%',
          },
        },
        {
          key: 'currentStoreName',
          label: 'Cửa hàng hiện tại',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '13%',
          },
        },
        {
          key: 'targetStoreName',
          label: 'Cửa hàng chuyển',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '13%',
          },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '13%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'approvedByName',
          label: 'Người duyệt',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '13%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'createdAt',
          label: 'Ngày tạo',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '13%',
          },
          tdClass: 'text-center',
          formatter: (value) => {
            return convertToDateSlash(value);
          },
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            width: '5%',
          },
        },
      ],
      dpConfigs: DP_CONFIG,
      listForms: [],
      isLoading: false,
    };
  },
  created() {
    this.fetchStore();
    this.userInfo = getEmployeeFromLocal();
    this.statusOptions = TRANSFER_STORE_STATUS;
    const employeeInfo = JSON.parse(
      window.localStorage.getItem('employee_info'),
    );

    this.employeeId = employeeInfo?.employeeId || null;
    this.jobTitleId = employeeInfo?.jobTitleId || null;

    // Nếu đang ở route profile/transfer-store-forms tự động filter theo employeeId hiện tại
    if (
      this.$route.path === '/profile/transfer-store-forms' &&
      this.userInfo?.id
    ) {
      this.params.employeeId = this.userInfo.id;
      this.searchEmployee = this.userInfo.fullName || '';
    }

    this.fetchTransferStoreForms();
  },
  methods: {
    showAddTransferStoreFormModal() {
      this.$refs['add-transfer-form-modal'].showModal();
    },
    handleTabsStatus(status, indexTab) {
      this.tabIndex = indexTab;
      this.params.status = status;
      this.fetchTransferStoreForms();
    },
    async onFilter() {
      this.params.page = 1;

      this.$route.query.page = 1;
      this.$router.push({
        name: this.isMyForms
          ? 'profile-transfer-store-forms'
          : 'list-transfer-store-forms',
      });
      this.fetchTransferStoreForms();
    },
    raisePermissionDenied() {
      makeToastFaile('Bạn không có quyền truy cập vào module này.');
    },
    checkPermissionByEmployId(item) {
      if (item.jobTitleId == JOB_TITLE.GD) return true;
      const employee = getEmployeeFromLocal();
      return employee.id !== item.employeeId;
    },
    getAvailableActions(item) {
      const currentEmployee = getEmployeeFromLocal();
      const actions = [];
      const hasUpdatePermission = this.checkPermission(
        'TRANSFER_STORE_FORM_UPDATE',
      );
      const canApprove =
        hasUpdatePermission && this.checkPermissionByEmployId(item);

      // Action: Duyệt và chuyển (chỉ khi PENDING và có quyền)
      if (canApprove && item.status === this.statusEnum.PENDING) {
        actions.push({
          key: 'approve-transfer',
          label: 'Duyệt và chuyển',
          class: 'text-primary',
          icon: 'flaticon2-check-mark text-primary',
          modalId: 'md-change-store',
          handler: () => this.onOpenModalApproveTransfer(item),
        });

        // Action: Duyệt (chỉ khi PENDING và có quyền)
        actions.push({
          key: 'approve',
          label: 'Duyệt',
          class: 'text-success',
          icon: 'flaticon2-check-mark text-success',
          modalId: 'modal-approve',
          handler: () => this.onOpenModalApprove(item),
        });

        // Action: Từ chối (chỉ khi PENDING và có quyền)
        actions.push({
          key: 'reject',
          label: 'Từ chối',
          class: 'text-warning',
          icon: 'flaticon2-exclamation text-warning',
          modalId: 'modal-reject',
          handler: () => this.onOpenModalReject(item),
        });
      }

      //Thêm action từ chối cho đơn đã duyệt/ đã duyệt và chuyển
      if (
        canApprove &&
        (item.status === this.statusEnum.APPROVED ||
          item.status === this.statusEnum.APROVED_TRANSFER)
      ) {
        actions.push({
          key: 'reject-transfer',
          label: 'Từ chốt',
          class: 'text-primary',
          icon: 'flaticon2-exclamation text-warning',
          modalId: 'modal-reject-transfer',
          handler: () => this.onOpenModalRejectTransfer(item),
        });
      }

      // Xoá đơn của chính mình
      if (
        this.checkPermission('TRANSFER_STORE_FORM_DELETE') &&
        item.employeeId === currentEmployee.id
      ) {
        actions.push({
          key: 'delete',
          label: 'Xoá đơn',
          class: 'text-danger',
          icon: 'flaticon2-cancel text-danger',
          modalId: 'modal-delete',
          handler: () => this.onOpenModalDelete(item),
        });
      }

      return actions;
    },
    fetchTransferStoreForms: async function () {
      if (this.isLoading) return;
      this.isLoading = true;
      const params = this.getParamFilter();
      ApiService.query('v1/transfer-store-forms', { params })
        .then((response) => {
          const resData = response.data.data;
          this.listForms = resData.dataset;
          this.totalItems = resData.totalRow;
          this.numberOfPages = resData.totalPage;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.resetSelectManyItem();
        });
    },

    getParamFilter() {
      return {
        page: this.params.page,
        status: this.params.status,
        pageSize: this.params.pageSize,
        fromDate: formatDBDate(this.params.fromDate),
        toDate: formatDBDate(this.params.toDate),
        employeeId: this.params.employeeId,
        currentStoreId: this.params.currentStoreId,
        targetStoreId: this.params.targetStoreId,
      };
    },
    onInputChangeCurrentStore(text) {
      if (!text) {
        text = '';
      }
      this.params.currentStoreId = null;
      this.searchCurrentStore = text;
      const filteredData = this.options
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.params.pageSize);

      this.filteredOptions = [...filteredData];
    },
    onInputChangeTargetStore(text) {
      if (!text) {
        text = '';
      }
      this.params.targetStoreId = null;
      this.searchTargetStore = text;
      const filteredData = this.options
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.params.pageSize);

      this.filteredOptions = [...filteredData];
    },
    fetchStore: async function () {
      ApiService.get('/stores/getStores').then((response) => {
        const stores = response.data.data;
        this.options = stores.map((element) => {
          return {
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            suggestionName: element.shortName + ' ( ' + element.name + ')',
          };
        });
        this.filteredOptions = [...this.options];
        this.searchCurrentStore = '';
        this.searchTargetStore = '';
      });
    },
    onEmployeeSelected(employee) {
      this.params.employeeId = employee ? employee.id : null;
    },
    onApprovedBySelected(employee) {
      this.params.approvedById = employee ? employee.id : null;
    },
    onSelectedCurrentStore(option) {
      this.params.currentStoreId = option.item.id;
      this.searchCurrentStore = option.item.name;
    },
    onSelectedTargetStore(option) {
      this.params.targetStoreId = option.item.id;
      this.searchTargetStore = option.item.name;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    getLinkDoc(item) {
      const path = this.isMyForms
        ? '/profile/transfer-store-forms/edit-form'
        : '/transfer-store-forms/edit-form';
      return `#${path}?id=${item.id}`;
    },
    handleKeydown() {
      this.startedTyping();

      this.stoppedTyping(this.onFilter);
    },
    reset() {
      this.search = '';
      this.searchApprovedBy = '';

      // Nếu đang ở chế độ myForms, giữ employeeId của user hiện tại
      const employeeId =
        this.isMyForms && this.userInfo?.id ? this.userInfo.id : null;
      const searchEmployee =
        this.isMyForms && this.userInfo?.fullName ? this.userInfo.fullName : '';

      this.searchEmployee = searchEmployee;
      this.params = {
        employeeId: employeeId,
        page: 1,
        status: null,
        pageSize: 10,
        fromDate: null,
        toDate: null,
        currentStoreId: null,
        targetStoreId: null,
      };
      this.searchCurrentStore = null;
      this.searchTargetStore = null;
      this.statusOptions = TRANSFER_STORE_STATUS;
      this.listForms = [];
      this.resetSelectManyItem();
      this.fetchTransferStoreForms();
    },
    resetSelectManyItem() {
      this.selections = [];
      this.allowUpdateManyItems = false;
      this.checkAllItems = false;
    },
    formatMoney(number) {
      return convertPrice(number);
    },
    editItem(item) {
      const path = this.isMyForms
        ? '/profile/transfer-store-forms/edit-form'
        : '/transfer-store-forms/edit-form';
      this.$router.push({
        path: path,
        query: { id: item.id },
      });
    },
    // Helper methods for API calls
    async updateTransferStoreForm(formId, reqData, options = {}) {
      const {
        onSuccess,
        onError,
        onFinally,
        refreshDelay = 0,
        autoRefresh = true,
      } = options;

      try {
        const res = await ApiService.update(
          'v1/transfer-store-forms',
          formId,
          reqData,
        );
        makeToastSuccess(res.data.message);
        if (autoRefresh) {
          if (refreshDelay > 0) {
            setTimeout(() => {
              this.fetchTransferStoreForms();
            }, refreshDelay);
          } else {
            this.fetchTransferStoreForms();
          }
        }
        if (onSuccess) onSuccess(res);
      } catch (err) {
        makeToastFaile(err.response?.data?.message || 'Có lỗi xảy ra');
        if (onError) onError(err);
      } finally {
        if (onFinally) onFinally();
      }
    },

    async deleteTransferStoreForm(formId, options = {}) {
      const {
        onSuccess,
        onError,
        onFinally,
        refreshDelay = 500,
        autoRefresh = true,
      } = options;

      try {
        const res = await ApiService.delete(
          `v1/transfer-store-forms/${formId}`,
        );
        makeToastSuccess(res.data.message);
        if (autoRefresh) {
          setTimeout(() => {
            this.fetchTransferStoreForms();
          }, refreshDelay);
        }
        if (onSuccess) onSuccess(res);
      } catch (err) {
        makeToastFaile(err.response?.data?.message || 'Có lỗi xảy ra');
        if (onError) onError(err);
      } finally {
        if (onFinally) onFinally();
      }
    },

    async updateManyTransferStoreForms(ids, reqData, options = {}) {
      const { onSuccess, onError, onFinally } = options;
      const responsesFail = [];
      const responsesSuccess = [];

      for (const id of ids) {
        try {
          await ApiService.update('v1/transfer-store-forms', id, reqData);
          const formItem = this.listForms.find((item) => item.id === id);
          if (formItem) responsesSuccess.push(formItem);
        } catch (err) {
          responsesFail.push(err.response?.data?.message || 'Có lỗi xảy ra');
        }
      }

      this.handleBatchResponse(responsesSuccess, responsesFail, ids.length);

      if (onFinally) onFinally();
      if (responsesSuccess.length && onSuccess) onSuccess(responsesSuccess);
      if (responsesFail.length && onError) onError(responsesFail);
    },

    async deleteManyTransferStoreForms(ids, options = {}) {
      const { onSuccess, onError, onFinally } = options;
      const responsesFail = [];
      const responsesSuccess = [];

      for (const id of ids) {
        try {
          await ApiService.delete(`v1/transfer-store-forms/${id}`);
          const formItem = this.listForms.find((item) => item.id === id);
          if (formItem) responsesSuccess.push(formItem);
        } catch (err) {
          responsesFail.push(err.response?.data?.message || 'Có lỗi xảy ra');
        }
      }

      this.handleBatchResponse(responsesSuccess, responsesFail, ids.length);

      if (onFinally) onFinally();
      if (responsesSuccess.length && onSuccess) onSuccess(responsesSuccess);
      if (responsesFail.length && onError) onError(responsesFail);
    },

    handleBatchResponse(responsesSuccess, responsesFail, totalCount) {
      if (responsesFail.length) {
        let msgResponse = `Cập nhật không thành công ${responsesFail.length} phiếu của:`;
        for (let [i, response] of responsesFail.entries()) {
          if (i !== 0) {
            msgResponse += ', ';
          }
          msgResponse += `${response}`;
        }
        makeToastFaile(msgResponse);
      }

      if (responsesSuccess.length) {
        if (responsesSuccess.length === totalCount) {
          makeToastSuccess('Cập nhật thành công.');
        } else {
          let msgResponse = `Cập nhật thành công ${responsesSuccess.length} phiếu của:`;
          for (const [i, response] of responsesSuccess.entries()) {
            if (i !== 0) {
              msgResponse += ', ';
            }
            msgResponse += `${response.employeeName} ${response.employeeCode || ''}`;
          }
          makeToastSuccess(msgResponse);
        }
      }

      setTimeout(() => {
        this.fetchTransferStoreForms();
      }, 500);
    },

    hideModalApproveTransfer() {
      this.$refs.modalApproveTransfer.hide();
      this.currentApprovedFormId = null;
    },
    hideModalApprove() {
      this.$refs.modalApprove.hide();
      this.currentApprovedFormId = null;
    },
    hideModalReject() {
      this.$refs.modalReject.hide();
      this.currentRejectedFormId = null;
    },
    hideModalRejectTransfer() {
      this.$refs.modalRejectTransfer?.hide();
      this.currentRejectedFormId = null;
    },
    hideModalDelete() {
      this.$refs.modalDelete.hide();
      this.currentDeletedFormId = null;
    },
    onHandleApproveTransfer() {
      this.updateTransferStoreForm(
        this.currentApprovedFormId,
        { status: TRANSFER_STORE_FORM_STATUS.APROVED_TRANSFER },
        {
          onFinally: () => {
            this.currentApprovedFormId = null;
            this.$refs.modalApproveTransfer.hide();
          },
        },
      );
    },
    onHandleApprove() {
      this.updateTransferStoreForm(
        this.currentApprovedFormId,
        { status: TRANSFER_STORE_FORM_STATUS.APPROVED },
        {
          onFinally: () => {
            this.currentApprovedFormId = null;
            this.$refs.modalApprove.hide();
          },
        },
      );
    },
    onHandleReject() {
      this.updateTransferStoreForm(
        this.currentRejectedFormId,
        { status: TRANSFER_STORE_FORM_STATUS.REJECTED },
        {
          refreshDelay: 500,
          onFinally: () => {
            this.currentRejectedFormId = null;
            this.$refs.modalReject.hide();
          },
        },
      );
    },
    onHandleRejectTransfer() {
      this.updateTransferStoreForm(
        this.currentRejectedFormId,
        { status: TRANSFER_STORE_FORM_STATUS.REJECTED },
        {
          refreshDelay: 500,
          onFinally: () => {
            this.currentRejectedFormId = null;
            this.$refs.modalRejectTransfer?.hide();
          },
        },
      );
    },
    onHandleDelete() {
      this.deleteTransferStoreForm(this.currentDeletedFormId, {
        onFinally: () => {
          this.currentDeletedFormId = null;
          this.$refs.modalDelete.hide();
        },
      });
    },
    async onHandleApproveTransferManyItems() {
      await this.updateManyTransferStoreForms(
        this.selections,
        { status: TRANSFER_STORE_FORM_STATUS.APROVED_TRANSFER },
        {
          onFinally: () => {
            this.$refs.modalApproveTransferManyItems?.hide();
          },
        },
      );
    },

    async onHandleApproveManyItems() {
      await this.updateManyTransferStoreForms(
        this.selections,
        { status: TRANSFER_STORE_FORM_STATUS.APPROVED },
        {
          onFinally: () => {
            this.$refs.modalApproveManyItems.hide();
          },
        },
      );
    },

    async onHandleRejectManyItems() {
      await this.updateManyTransferStoreForms(
        this.selections,
        { status: TRANSFER_STORE_FORM_STATUS.REJECTED },
        {
          onFinally: () => {
            this.$refs.modalRejectManyItems.hide();
          },
        },
      );
    },
    async onHandleDeleteManyItems() {
      await this.deleteManyTransferStoreForms(this.selections, {
        onFinally: () => {
          this.$refs.modalDeleteManyItems.hide();
        },
      });
    },
    onSelectFormItem(id) {
      if (this.selections.includes(id)) {
        this.selections = this.selections.filter((_id) => _id !== id);
      } else {
        this.selections = [...this.selections, id];
      }

      this.checkAllowUpdateManyItems();
    },
    checkAllowUpdateManyItems() {
      if (!this.selections.length) return (this.allowUpdateManyItems = false);
      if (!this.checkPermission('TRANSFER_STORE_FORM_UPDATE')) {
        this.allowUpdateManyItems = false;
        return false;
      }

      let isAllowed = true;
      let formsOpenModal = [];
      for (const selectedItem of this.selections) {
        let formSelectedItem = this.listForms.find(
          (item) => item.id === selectedItem,
        );
        if (
          !formSelectedItem ||
          formSelectedItem.status !== 1 ||
          (formSelectedItem.createdBy === this.employeeId &&
            this.jobTitleId !== 1)
        ) {
          isAllowed = false;
          break;
        }

        let formItem = this.listForms.find((item) => item.id === selectedItem);
        if (formItem) {
          formsOpenModal.push(formItem);
        }
      }

      if (!isAllowed) {
        this.currentManyFormsOpenModal = [];
      } else {
        this.currentManyFormsOpenModal = formsOpenModal;
      }

      this.allowUpdateManyItems = isAllowed;
      return isAllowed;
    },
    onCheckAllItems() {
      if (!this.checkAllItems) {
        this.resetSelectManyItem();
        return;
      }
      this.selections = this.listForms.map((item) => item.id);
      this.checkAllowUpdateManyItems();
    },
    hideModalApproveTransferManyItems() {
      this.$refs.modalApproveTransferManyItems?.hide();
    },
    hideModalApproveManyItems() {
      this.$refs.modalApproveManyItems.hide();
    },
    hideModalRejectManyItems() {
      this.$refs.modalRejectManyItems.hide();
    },
    hideModalDeleteManyItems() {
      this.$refs.modalDeleteManyItems.hide();
    },
    onOpenModalApprove(item) {
      this.currentApprovedFormId = item.id;
      this.currentFormOpenModal = item;
      this.$nextTick(() => {
        this.$refs.modalApprove?.show();
      });
    },
    onOpenModalApproveTransfer(item) {
      this.currentManyFormsOpenModal = [item];
      this.currentApprovedFormId = item.id;
      this.currentFormOpenModal = item;
      this.$nextTick(() => {
        this.$bvModal.show('md-change-store');
      });
    },
    onOpenModalReject(item) {
      this.currentRejectedFormId = item.id;
      this.currentFormOpenModal = item;
      this.$nextTick(() => {
        this.$refs.modalReject?.show();
      });
    },
    onOpenModalDelete(item) {
      this.currentDeletedFormId = item.id;
      this.currentFormOpenModal = item;
      this.$nextTick(() => {
        this.$refs.modalDelete?.show();
      });
    },
    onOpenModalRejectTransfer(item) {
      this.currentRejectedFormId = item.id;
      this.currentFormOpenModal = item;
      this.$nextTick(() => {
        this.$refs.modalRejectTransfer?.show();
      });
    },
    checkPermissionAllowUpdate(targetStoreId) {
      const { listStoreId, jobTitleId } = this.userInfo;
      const listStoreIdArray = listStoreId.split(', ');

      if (
        jobTitleId === JOB_TITLE.GD ||
        (JOB_TITLE_APPROVE.includes(jobTitleId) &&
          listStoreIdArray.includes(targetStoreId.toString()))
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu chuyển cửa hàng', route: 'transfer-store-forms' },
      { title: 'Danh sách phiếu yêu cầu chuyển cửa hàng' },
    ]);
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    computedFields() {
      if (this.params.status != 1)
        return this.fields.filter((field) => !field.requiresPermission);
      else return this.fields;
    },
    isMyForms() {
      return this.$route.path === '/profile/transfer-store-forms';
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    },
    storeName() {
      const { storeId } = this.userInfo;
      const store = this.filteredOptions.find((item) => item.id === storeId);
      return store.name;
    },
  },
  watch: {
    selections(newSelections) {
      if (newSelections?.length === this.listForms.length) {
        this.checkAllItems = true;
        return;
      }
      this.checkAllItems = false;
    },
    fetchTransferStoreForms() {
      this.fetchTransferStoreForms();
    },
  },
  components: {
    Loader,
    KTCodePreview,
    StatusForm,
    datePicker,
    Autosuggest,
    EmployeeSearch,
    AddTransferStoreFormModal,
    TransferStoreFormActionModal,
    TransferStoreFormManyItemsModal,
    TransferStoreInformation,
    BPaginationNavCustom,
    VclTable,
  },
};
</script>

<style scoped>
.icon:hover {
  background-color: #90c6fc;
}
</style>
<style>
.tab-status {
  background-color: ghostwhite;
}
.tab-status .nav .nav-link {
  font-weight: bold;
  font-size: 1.1rem;
  color: black;
}
.tab-status .nav .nav-link:hover {
  color: slateblue;
}
.tab-status .nav .nav-link.active {
  color: slateblue;
}
</style>
